import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Api from "../Api.js";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
// import "../Styles/ProfileActivityUpcoming.css"; 

function ProfileActivityUpcoming() {
  const [upcomingActivities, setUpcomingActivities] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3; // 👈 cards per page
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUpcomingActivities = async () => {
      const accessToken = localStorage.getItem("accessToken");
      if (!accessToken) {
        console.error("No access token found");
        navigate("/login");
        return;
      }
      try {
        const response = await Api.get("/activities/bookings/paid", {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        console.log("Upcoming activities data:", response.data.data);
        setUpcomingActivities(response.data.data);
      } catch (error) {
        console.error("Error fetching upcoming activities:", error);
      }
    };
    fetchUpcomingActivities();
  }, [navigate]);

  // 🔹 Pagination logic
  const totalPages = Math.ceil(upcomingActivities.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = upcomingActivities.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="profileActivity_container">
      {upcomingActivities.length === 0 ? (
        <p>No upcoming activities available.</p>
      ) : (
        <>
          {/* 🔹 Activity Cards */}
          {currentItems.map((activity) => (
            <div className="tripCard_wrapper" key={activity.id}>
              <div className="tripCard_image">
                <img
                  src={activity?.activity?.image}
                  alt={activity?.activity?.name}
                />
              </div>
              <div className="tripCard_content">
                <h2 className="tripCard_title">{activity?.activity?.name}</h2>
                <p className="tripCard_date review_class">
                  {activity?.activity?.description}
                </p>
                <p className="tripCard_date" style={{ fontWeight: "600", margin: "0" }}>
                  Destintion: {activity?.activity?.booked_destination?.name}
                </p>
                <p className="tripCard_date" style={{ fontWeight: "600", margin: "0" }}>
                  Amount: ₹{activity?.total_amount}
                </p>
                <p className="tripCard_date" style={{ fontWeight: "600", margin: "4px" }}>
                  Seats: {activity?.seats}
                </p>
                <div className="tripCard_buttons">
                  <button className="tripCard_btnDetails">Details</button>
                  <button className="tripCard_btnCancel">Cancel</button>
                </div>
              </div>
            </div>
          ))}

          {/* 🔹 MUI Pagination (only arrows, no first/last buttons) */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 3,
              marginBottom: 3,
            }}
          >
            <Stack spacing={2}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
                shape="rounded"
                siblingCount={1}
                boundaryCount={0}
              />
            </Stack>
          </Box>
        </>
      )}
    </div>
  );
}

export default ProfileActivityUpcoming;
